(function(){
  var busy = false;
  var queue = [];

  /* Lock cart during any operation */
  function lockCart() { busy = true; }
  function unlockCart() {
    busy = false;
    /* Process next queued action if any */
    if (queue.length > 0) {
      var next = queue.shift();
      next();
    }
  }

  /* Intercept ALL fetch calls to cart endpoints */
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var isCartOp = typeof url === 'string' && (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );

    if (isCartOp) {
      if (busy) {
        /* Return a rejected promise to block duplicate */
        return Promise.reject(new Error('Cart busy'));
      }
      lockCart();
      return origFetch.apply(this, arguments)
        .then(function(response) {
          /* Small delay to let DOM update before allowing next op */
          setTimeout(unlockCart, 300);
          return response;
        })
        .catch(function(err) {
          setTimeout(unlockCart, 300);
          throw err;
        });
    }

    return origFetch.apply(this, arguments);
  };

  /* Block rapid clicks on cart buttons */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.upsell-add-button, .quantity__button, .cart-item__remove, [data-cart-remove]');
    if (!btn) return;
    if (busy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  /* Block rapid form submits */
  document.addEventListener('submit', function(e) {
    if (!e.target.action || e.target.action.indexOf('/cart/add') === -1) return;
    if (busy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);
})();
